import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { GoogleAuthProvider, getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBelWBonN6wCI9u-P3NLmNQD-IBSuncpn0",
  authDomain: "whatsapp-clone-50364.firebaseapp.com",
  projectId: "whatsapp-clone-50364",
  storageBucket: "whatsapp-clone-50364.appspot.com",
  messagingSenderId: "328816300186",
  appId: "1:328816300186:web:74ad1f5bbf91ef383d0f23"
};

const firebaseApp = initializeApp(firebaseConfig);

const db = getFirestore(firebaseApp);

const auth = getAuth();

const provider = new GoogleAuthProvider();

export { auth, provider };
export default db;
